import React from 'react';
import { ChevronHeaderSC } from './chevron-header-styled';
import { ReactComponent as ChevronSVG } from '../../../../assets/svg/icon-chevron-round-right.svg';
import { FormattedMessage } from 'react-intl';

interface IChevronHeaderProps {
  textId: string;
}

const ChevronHeader: React.FC<IChevronHeaderProps> = ({ textId }) => (
  <ChevronHeaderSC>
    <ChevronSVG />
    <h3>
      <FormattedMessage id={textId} />
    </h3>
  </ChevronHeaderSC>
);

export default ChevronHeader;
